import React, { useRef, useEffect } from 'react';

export const getUserColor = (user) => {
  let charecter =
    user &&
    user
      .split('')[0]
      .toLowerCase()
      .split('')
      .map((char) => {
        let charCode = char.charCodeAt(0);
        if (charCode >= 97 && charCode <= 122) {
          return charCode - 96; // 'a' is 97 in ASCII, so 'a' - 96 is 1
        }
        return char;
      });
  return Math.round(charecter / 6) + 1;
};

export const getShortLetters = (name) => {
  if (typeof name !== 'string' || !name.trim()) {
    return name; // Return an empty string if name is not a valid string
  }

  const words = name.split(' ');
  const initials =
    words.length > 2
      ? words[0][0] + words[1][0]
      : words.map((word) => word[0]).join('');

  return initials.toUpperCase(); // Convert initials to uppercase
};

// export function useHorizontalScroll() {
//   console.log('hi');
//   const elRef = useRef();
//   useEffect(() => {
//     const el = elRef.current;
//     if (el) {
//       const onWheel = (e) => {
//         const strength = Math.abs(e.deltaY);
//         if (e.deltaY == 0) return;
//         e.preventDefault();
//         el.scrollTo({
//           left: el.scrollLeft + e.deltaY,
//           // large scrolls with smooth animation behavior will lag, so switch to auto
//           behavior: strength > 70 ? 'auto' : 'smooth',
//         });
//       };
//       el.addEventListener('wheel', onWheel);
//       return () => el.removeEventListener('wheel', onWheel);
//     }
//   }, []);
//   return elRef;
// }

export function useHorizontalScroll(scrollSpeed = 3) {
  const elRef = useRef();

  useEffect(() => {
    const el = elRef.current;

    const onWheel = (e) => {
      const target = e.target;

      // Traverse up the DOM to check if we are inside a vertically scrollable element
      let scrollableVertically = false;
      let currentElement = target;

      while (currentElement && currentElement !== el) {
        if (currentElement.scrollHeight > currentElement.clientHeight) {
          scrollableVertically = true;
          break;
        }
        currentElement = currentElement.parentElement;
      }

      // If we find a vertically scrollable element (like Kanban card), allow vertical scrolling
      if (scrollableVertically) {
        return;
      }

      // Check if the main container can scroll horizontally
      const canScrollHorizontally = el.scrollWidth > el.clientWidth;

      // Handle horizontal scrolling for the main container
      if (canScrollHorizontally && e.deltaY !== 0) {
        e.preventDefault();
        el.scrollTo({
          left: el.scrollLeft + e.deltaY * scrollSpeed,
          behavior: 'smooth',
        });
      }
    };

    if (el) {
      el.addEventListener('wheel', onWheel);
    }

    // Clean up the event listener on unmount or re-renders
    return () => {
      if (el) {
        el.removeEventListener('wheel', onWheel);
      }
    };
  }, [scrollSpeed, elRef.current]); // Dependencies include the scrollSpeed and elRef.current to ensure re-application

  return elRef;
}
